<template>
	<div class="row">
		<div class="col-12 col-md-8 offset-md-2">
			<form @submit.prevent="save('invoices')">
				<div class="card">
					<div class="card-body">
						<div class="air__utils__heading">
							<h5>General</h5>
						</div>

						<div class="row">
							<div class="col-sm-5">
								<a-form-item
									label="Nombre de la empresa"
									required
								>
									<a-input
										v-model="config.EmpresaNombre"
										class="w-100"
									>
										<fa-icon
											slot="prefix"
											:icon="['fas', 'home']"
										/>
									</a-input>
								</a-form-item>

								<a-form-item
									label="CIF"
									required
								>
									<a-input
										v-model="config.EmpresaCIF"
										class="w-100"
									>
										<fa-icon
											slot="prefix"
											:icon="['fas', 'id-card']"
										/>
									</a-input>
								</a-form-item>
							</div>

							<div class="col-sm-5">
								<a-form-item
									label="Nombre comercial"
									required
								>
									<a-input
										v-model="config.EmpresaNombreComercial"
										class="w-100"
									>
										<fa-icon
											slot="prefix"
											:icon="['fas', 'home']"
										/>
									</a-input>
								</a-form-item>

								<a-form-item label="Email">
									<a-input
										v-model="config.EmpresaEmail"
										type="email"
									>
										<fa-icon
											slot="prefix"
											:icon="['fas', 'envelope']"
										/>
									</a-input>
								</a-form-item>
							</div>

							<div class="col-sm-2">
								<a-form-item label="Color">
									<v-swatches
										v-model="config.FacturaColor"
										fallback-ok-class="mt-2"
										fallback-ok-text="Modificar"
										show-fallback
										popover-x="left"
										fallback-input-type="color"
									/>
								</a-form-item>
							</div>
						</div>

						<div class="row mt-5 mt-sm-0">
							<div class="col-12 col-sm-6">
								<a-form-item
									label="Direccion"
									required
								>
									<a-input v-model="config.EmpresaDireccion">
										<fa-icon
											slot="prefix"
											:icon="['fas', 'map-marked-alt']"
										/>
									</a-input>
								</a-form-item>

								<a-form-item
									label="Teléfono"
									class="mb-0"
								>
									<a-input v-model="config.EmpresaTelefono">
										<fa-icon
											slot="prefix"
											:icon="['fas', 'phone']"
										/>
									</a-input>
								</a-form-item>
							</div>

							<div class="col-12 col-sm-6 align-self-end">
								<a-upload
									name="logo"
									class="logoUpload"
									list-type="picture-card"
									:custom-request="uploadLogo"
									:show-upload-list="false"
									:before-upload="beforeUpload"
									accept="image/x-png,image/gif,image/jpeg"
								>
									<img
										v-if="imageUrl"
										:src="imageUrl"
										alt="avatar"
									>
									<div v-else>
										<a-icon :type="uploading ? 'loading' : 'plus'" />
										<div class="ant-upload-text">
											Subir
										</div>
									</div>
								</a-upload>
							</div>
						</div>

						<a-button
							class="mt-4 float-right"
							type="primary"
							:loading="loading"
							:disabled="!validated('general')"
							@click="save('general')"
						>
							Guardar
						</a-button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';
import '@/application/assets/scss/vueSwatches';

export default {
	components: { VSwatches },
	data() {
		return {
			config: {
				EmpresaNombre: '',
				EmpresaNombreComercial: '',
				EmpresaCIF: '',
				EmpresaEmail: '',
				EmpresaDireccion: '',
				EmpresaWeb: '',
				EmpresaTelefono: '',
				EmpresaLogo: '',
				FacturaColor: ''
			},
			loading: false,
			uploading: false,
			imageUrl: ''
		};
	},
	async created() {
		const config = await this.$gestios.config.list(Object.keys(this.config));

		if (config.ok) {
			Object.keys(this.config).forEach((key) => {
				this.config[key] = config.data[key];
			});

			if (this.config.EmpresaLogo) this.imageUrl = this.config.EmpresaLogo;
		}
	},
	methods: {
		async save(section) {
			if (this.validated(section)) {
				let params;

				this.loading = true;

				switch (section) {
					case 'general':
						params = {
							EmpresaNombre: this.config.EmpresaNombre,
							EmpresaNombreComercial: this.config.EmpresaNombreComercial,
							EmpresaCIF: this.config.EmpresaCIF,
							EmpresaEmail: this.config.EmpresaEmail,
							EmpresaDireccion: this.config.EmpresaDireccion,
							EmpresaWeb: this.config.EmpresaWeb,
							EmpresaTelefono: this.config.EmpresaTelefono,
							EmpresaLogo: this.config.EmpresaLogo,
							FacturaColor: this.config.FacturaColor
						};
						break;

					default:
						return;
				}

				const result = await this.$gestios.config.edit(params);
				if (result.ok) this.$toast.success('Configuracion guardada');

				this.loading = false;
			}
		},
		validated(type) {
			if (type === 'general') {
				if (this.config.EmpresaNombre
					&& this.config.EmpresaCIF
					&& this.config.EmpresaDireccion
					&& this.config.EmpresaEmail
					&& this.config.EmpresaNombreComercial) return true;

				return false;
			}

			return false;
		},
		uploadLogo(info) {
			this.getBase64(info.file, async (imageUrl) => {
				const result = await this.$gestios.config.edit({ EmpresaLogo: imageUrl });
				if (result.ok) this.$toast.success('Configuracion guardada');

				this.imageUrl = imageUrl;
				this.uploading = false;
			});
		},
		beforeUpload(file) {
			const isValid = file.type === 'image/jpeg' || file.type === 'image/png';
			if (!isValid) this.$message.error('Solo puedes subir imagenes en jpg y png');

			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) this.$message.error('La imagen debe pesar menos de 2MB');

			return isValid && isLt2M;
		},
		getBase64(img, callback) {
			const reader = new FileReader();
			reader.addEventListener('load', () => callback(reader.result));
			reader.readAsDataURL(img);
		}
	}
};
</script>

<style lang="scss">
.logoUpload {
	.ant-upload.ant-upload-select-picture-card {
		width: 100%;
		height: 150px;
		margin-bottom: 0;

		img {
			max-width: 100%;
			max-height: 235px;
		}
	}
}
</style>
